import { useMutation } from "@apollo/client";
import { DISMISS_PREQUALIFICATION_BANNER } from "./dismiss-prequalification-banner.mutation";

export const useDismissPrequalificationBanner = () => {
  const [dismissPrequalificationBanner, { loading, error }] = useMutation(
    DISMISS_PREQUALIFICATION_BANNER,
  );

  return { dismissPrequalificationBanner, loading, error };
};
